import { cx } from '@linaria/core';

import { SizeButtonBase } from '../SizeButtonBase';
import type { SizeButtonBaseProps } from '../types';
import { styledButton } from './styles';

export const SizeCommonButtonBase = ({
	size = 'S',
	className,
	...props
}: SizeButtonBaseProps) => {
	return (
		<SizeButtonBase
			size={size}
			className={cx(className, styledButton)}
			{...props}
		/>
	);
};
